import { render } from "./LimitTag.vue?vue&type=template&id=5636a862&scoped=true"
import script from "./LimitTag.vue?vue&type=script&lang=js"
export * from "./LimitTag.vue?vue&type=script&lang=js"

import "./LimitTag.vue?vue&type=style&index=0&id=5636a862&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5636a862"],['__file',"src/scripts/portfolioEditor/modals/caseStudyGenerator/components/LimitTag.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5636a862"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5636a862', __exports__)) {
    api.reload('5636a862', __exports__)
  }
  
  module.hot.accept("./LimitTag.vue?vue&type=template&id=5636a862&scoped=true", () => {
    api.rerender('5636a862', render)
  })

}


export default __exports__